import { Injectable } from '@angular/core';
import { GridService } from './grid.service';
import { ActivatedRoute, Router } from "@angular/router";
import { environment } from 'environments/environment';
import { FormService } from './form.service';
import { DrakeSharedService } from './drake-shared.service';
import { CodiceBpService } from './codice-bp.service';
import { AuthService } from '../core/auth/auth.service';
import { GridComponent } from '@progress/kendo-angular-grid';



@Injectable({
  providedIn: 'root',
})
export class DrakeCustomScriptsService {
  public customScripts: any =  {}
    constructor(private router: Router, private authService: AuthService, private codiceBpService: CodiceBpService, private activatedRoute: ActivatedRoute, private gridService: GridService, private drakeSharedService: DrakeSharedService) {
    }

}
